/**
 * Who runs Spawnwire, and the other details the Community Rules, Terms of Service and Privacy Policy depend on.
 * Fill these in before publishing: a value still in [square brackets] appears on the pages exactly as written.
 * The optional sentences (`postalAddress`, `copyrightAgent`, `transferSafeguard`) are left out when set to ''.
 */
export const LEGAL = {
  /** When the pages last changed (YYYY-MM-DD), shown at the top of each one. Change it whenever you change them. */
  updated: '2026-11-02',

  operator: 'Spawnwire',
  country: 'Australia',
  /** Shown as a mailto link once it is a real address. */
  contactEmail: 'support@spawnwire.online',
  postalAddress: '',
  minimumAge: '13',

  website: 'spawnwire.online',
  statusSite: 'uptime.spawnwire.online',
  serverProvider: 'HostBRR',
  /** Where the VPS is. Left '' the policy says the servers may be outside Australia. */
  serverCountry: 'Germany',
  gameHost: 'CraftNodes',
  websiteHost: 'our web hosting company',

  /** SESSION_TTL_DAYS on the server. */
  sessionDays: '30',
  reportRetention: 'As long as needed to keep Spawnwire safe, and no more than 2 years after the account is closed',
  supportRetention: "As long as needed to help you, and no more than 2 years after the ticket's last message",
  /** Keep journald (or whatever stores the server's logs) to this. */
  logRetention: '30 days',
  backups: "If we keep backups, they're deleted within 30 days",
  replyTime: '30 days',

  changeNotice: 'at least 14 days',
  shutdownNotice: 'at least 30 days',
  liabilityCap: 'AUD $50',
  governingLaw: 'Australia',
  courts: 'Australia',

  copyrightAgent: '',
  transferSafeguard: '',
};
